import { createAction, props } from '@ngrx/store';
import {
  Parameter,
  CreateParameterRequest,
  UpdateParameterRequest,
  ParameterDetail
} from '../models/parameter.interface';

// Parameter actions
export const loadAllParameters = createAction('[Parameter] Load All Parameters');

export const loadAllParametersSuccess = createAction(
  '[Parameter] Load All Parameters Success',
  props<{ parameters: Parameter[] }>()
);

export const loadAllParametersFailure = createAction(
  '[Parameter] Load All Parameters Failure',
  props<{ error: string }>()
);

// Aliases for backward compatibility with tests
export const loadParameters = loadAllParameters;
export const loadParametersSuccess = loadAllParametersSuccess;
export const loadParametersFailure = loadAllParametersFailure;

export const selectParameter = createAction(
  '[Parameter] Select Parameter',
  props<{ parameter: Parameter | null }>()
);

export const createParameter = createAction(
  '[Parameter] Create Parameter',
  props<{ request: CreateParameterRequest }>()
);

export const createParameterSuccess = createAction(
  '[Parameter] Create Parameter Success',
  props<{ parameter: Parameter }>()
);

export const createParameterFailure = createAction(
  '[Parameter] Create Parameter Failure',
  props<{ error: string }>()
);

export const updateParameter = createAction(
  '[Parameter] Update Parameter',
  props<{ id: number; request: UpdateParameterRequest }>()
);

export const updateParameterSuccess = createAction(
  '[Parameter] Update Parameter Success',
  props<{ parameter: Parameter }>()
);

export const updateParameterFailure = createAction(
  '[Parameter] Update Parameter Failure',
  props<{ error: string }>()
);

export const fetchParameterById = createAction(
  '[Parameter] Fetch Parameter By Id',
  props<{ id: number }>()
);

export const fetchParameterByIdSuccess = createAction(
  '[Parameter] Fetch Parameter By Id Success',
  props<{ parameter: Parameter }>()
);

export const fetchParameterByIdFailure = createAction(
  '[Parameter] Fetch Parameter By Id Failure',
  props<{ error: string }>()
);

export const loadActiveParameters = createAction('[Parameter] Load Active Parameters');

export const loadActiveParametersSuccess = createAction(
  '[Parameter] Load Active Parameters Success',
  props<{ parameters: Parameter[] }>()
);

export const loadActiveParametersFailure = createAction(
  '[Parameter] Load Active Parameters Failure',
  props<{ error: string }>()
);

export const loadInactiveParameters = createAction('[Parameter] Load Inactive Parameters');

export const loadInactiveParametersSuccess = createAction(
  '[Parameter] Load Inactive Parameters Success',
  props<{ parameters: Parameter[] }>()
);

export const loadInactiveParametersFailure = createAction(
  '[Parameter] Load Inactive Parameters Failure',
  props<{ error: string }>()
);

// Parameter Detail actions
export const createParameterDetail = createAction(
  '[Parameter] Create Parameter Detail',
  props<{ parameterId: number; detail: Partial<ParameterDetail> }>()
);

export const createParameterDetailSuccess = createAction(
  '[Parameter] Create Parameter Detail Success',
  props<{ parameterId: number; detail: ParameterDetail }>()
);

export const createParameterDetailFailure = createAction(
  '[Parameter] Create Parameter Detail Failure',
  props<{ error: string }>()
);

export const updateParameterDetail = createAction(
  '[Parameter] Update Parameter Detail',
  props<{ parameterId: number; detailId: number; detail: Partial<ParameterDetail> }>()
);

export const updateParameterDetailSuccess = createAction(
  '[Parameter] Update Parameter Detail Success',
  props<{ parameterId: number; detail: ParameterDetail }>()
);

export const updateParameterDetailFailure = createAction(
  '[Parameter] Update Parameter Detail Failure',
  props<{ error: string }>()
);

// Error handling
export const clearParameterError = createAction('[Parameter] Clear Error');

// Cache management actions
export const invalidateCache = createAction('[Parameter] Invalidate Cache');

export const forceRefresh = createAction('[Parameter] Force Refresh');

export const setCacheValid = createAction(
  '[Parameter] Set Cache Valid',
  props<{ expiry: number }>()
);

export const clearCache = createAction('[Parameter] Clear Cache');
